import { SHOW_SUGGESTED_COACHES_NOTIFICATION, HIDE_SUGGESTED_COACHES_NOTIFICATION } from 'redux/constants';

const initialState = {
    show: true,
};

export default (state = initialState, action) => {

    const { type } = action;

    switch (type) {
        case SHOW_SUGGESTED_COACHES_NOTIFICATION:
            return {
                ...state,
                show: true,
            };
        case HIDE_SUGGESTED_COACHES_NOTIFICATION:
            return {
                ...state,
                show: false,
            };
        default:
            return state;
    }
}